import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 140px);
`;
